

import React from 'react';
import Avatar from '@mui/material/Avatar';
import Button from '@mui/material/Button';
import CssBaseline from '@mui/material/CssBaseline';
import TextField from '@mui/material/TextField';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import Link from '@mui/material/Link';
import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import { Lock } from 'lucide-react';
import Typography from '@mui/material/Typography';
import { makeStyles } from '@mui/styles';
import Container from '@mui/material/Container';
import { useSessionContext } from './SessionContext';
import { useNavigate } from "react-router-dom";
import { Backdrop, Switch } from '@mui/material';

function Copyright() {
    return (
        <Typography variant="body2" color="textSecondary" align="center">
            {process.env.npm_package_version ? process.env.npm_package_version : ''  + ' Copyright © ' }
            <Link color="inherit" href="https://mijak.com/" target="_blank">
                MiJak 2021-{new Date().getFullYear() } 
            </Link>
        </Typography>
    );
}

const useStyles = makeStyles((theme) => ({
    paper: {
        marginTop: theme.spacing(8),
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
    },
    avatar: {
        margin: theme.spacing(1),
        backgroundColor: theme.palette.secondary.main,
    },
    form: {
        width: '100%', // Fix IE 11 issue.
        marginTop: theme.spacing(1),
    },
    submit: {
        margin: theme.spacing(3, 0, 2),
    },
}));

export default function LoginScreen(props) {
    const { salt, successRedirect } = props;
    const classes = useStyles();
    const session = useSessionContext();
    const emailRef = React.createRef("")
    const passwordRef = React.createRef("")
    let navigate = useNavigate();


    function handleSignIn(e) {
        e.preventDefault();
        //console.log("handleSignin")
        try { 
            const aUser = session.authenticate(emailRef.current.value, passwordRef.current.value);
            if (aUser !== null && successRedirect) { 
                navigate(successRedirect);
            }
        } catch (error) { 
            console.log("error", error)
        }
    }


    return (
        <Container component="main" maxWidth="xs">
            <Backdrop
                 sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
                 open={true}
                 
            >
                <Button variant="contained" color="secondary"
                    onClick={ e=> { session.setOffline(true ) } }>
                        Skip login for now
                </Button>
            </Backdrop>
            <CssBaseline />
            <div className={classes.paper}>
                <Avatar className={classes.avatar}>
                    <Lock size={20} strokeWidth={2} />
                </Avatar>
                <Typography component="h1" variant="h5">
                    Sign in
        </Typography>
                <form className={classes.form} noValidate>
                    <TextField
                        inputRef={emailRef}
                        variant="outlined"
                        margin="normal"
                        required
                        fullWidth
                        id="email"
                        label="Email address"
                        name="email"
                        autoComplete="email"
                        autoFocus
                    />
                    <TextField
                        variant="outlined"
                        margin="normal"
                        required
                        fullWidth
                        inputRef={passwordRef}
                        name="password"
                        label="Password"
                        type="password"
                        id="password"
                        autoComplete="current-password"
                    />
                    <FormControlLabel
                        control={<Checkbox value="remember" color="primary" />}
                        label="Remember me"
                    />
                    <FormControlLabel
                        control={<Switch value={session.isOffline} color="primary" onChange={ e=> { session.setOffline(e.target.value ) }} />}
                        label="Offline mode"
                    />
                    <Button
                        type="submit"
                        disabled={session.isAuthenticating}
                        fullWidth
                        variant="contained"
                        color="primary"
                        className={classes.submit}
                        onClick={handleSignIn}
                    >
                        Sign in{ session.user ? ` as ${session.user.email}` : '' }
          </Button>
                    <Grid container>
                        <Grid item xs>
                            <Link href="#" variant="body2">
                                Forgot password?
              </Link>
                        </Grid>
                        <Grid item>
                            <Link href="/signup" variant="body2">
                                {"Don't have an account? Sign up"}
                            </Link>
                        </Grid>
                    </Grid>
                </form>
            </div>
            <Box mt={8}>
                <Copyright />
            </Box>
            <Link href="/oauth/login">P</Link>
        </Container>
    );
}
